import { NgModule } from '@angular/core';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { DtxStudioIntegrationComponent } from './dtx-studio-integration/dtx-studio-integration.component';
import { DtxStudioFeatureService } from './dtx-studio-feature.service';

@NgModule({
  declarations: [DtxStudioIntegrationComponent],
  imports: [NgSharedModule],
  providers: [DtxStudioFeatureService],
})
export class DtxStudioModule {}
